import _ from 'lodash'
class Alert {
  constructor(alertId, userId, createdAt, title, filter, isActive) {
    this.alertId = alertId
    this.userId = userId
    this.createdAt = createdAt
    this.title = title
    this.filter = filter
    this.isActive = isActive
  }

  entity() {
    return this._valueOrStar(
      this.filter.entity ||
      this.filter.operator ||
      this.filter.applicant ||
      this.filter.lessee
    )
  }

  legalLocation() {
    return [
      this._valueOrStar(this.filter.section),
      this._valueOrStar(this.filter.township),
      this._valueOrStar(this.filter.range),
      this._valueOrStar(this.filter.meridian)
    ].join('-')
  }

  urlEncode() {
    return _(this.filter)
      .omit(_.isUndefined)
      .omit(_.isNull)
      .omit(val => val === '')
      .assign({autoSearch: true})
      .map((value, key) => {
        return encodeURIComponent(key) + "=" + encodeURIComponent(value)
      })
      .thru(params => params.join("&"))
      .value()
  }

  _valueOrStar(v) {
    return (v || "*")
  }

  static fromJsonArray(alerts) {
    return _.map(
      alerts,
      alert => Alert.fromJson(alert)
    )
  }

  static fromJson(a) {
    return new Alert(
      a.alertId,
      a.userId,
      a.createdAt,
      a.title,
      a.filter,
      a.isActive)
  }

  static factory($resource, $log, config) {
    return $resource(
      config.alertResourcePath,
      {userId: '@userId'},
      {
        get: {
          method: 'GET',
          url: config.alertResourcePath + '/alert/:alertId',
          params: {alertId: '@alertId', userId: '@userId'},
          transformResponse: function(data, headers) {
            return data
          }
        },
        create: {
          method: 'POST'
        },
        query: {
          method: 'GET',
          transformResponse: function(data, headers) {
            var response
            try {
              response = angular.fromJson(data)
              response.alerts = Alert.fromJsonArray(response.alerts)
            } catch (e) {
              response = data
            }

            return response
          }
        },
        remove: {
          url: config.alertResourcePath + '/alert/:alertId',
          params: {userId: '@userId', alertId: '@alertId'},
          data: {isActive: '@isActive'},
          method: 'PUT'
        }
      }
    )
  }
}

Alert.factory.$inject = ['$resource', '$log', 'config']

export default Alert
